import React, { Component } from 'react'

class Pagination extends Component{
    renderButtons(){
        let buttons = [];
        for (var i = 1; i < this.props.data.last_page+1; i++){
            buttons.push(
                <li
                className={this.props.data.current_page === i ? "page-item active" : "page-item"}
                key={i}>
                    <a
                        className="page-link"
                        id={i} onClick={this.props.changePage}
                        href="#">
                        {i}
                    </a>
                </li>
            )
        }
        return buttons
    }
    render(){
        return(
            <div className="table-utils">
                <ul className="pagination float-left">
                    <li className={this.props.data.current_page === 1 ? "page-item disabled" : "page-item"}>
                        <a className="page-link" href="#" id={this.props.data.current_page - 1} onClick={this.props.changePage}>«</a>
                    </li>
                    {this.renderButtons()}
                    <li className={this.props.data.current_page === this.props.data.last_page ? "page-item disabled" : "page-item"}>
                        <a className="page-link" href="#" id={this.props.data.current_page + 1} onClick={this.props.changePage}>»</a>
                    </li>
                </ul>
                <div className="table-records-info float-right">
                    <span className="text-muted"> Mostrando los casos del {this.props.data.from} al {this.props.data.to}. Total casos: <b>{this.props.data.total}</b></span>
                </div>
                <br className="clearfix" />
            </div>
        )
    }
}
export default Pagination


// WEBPACK FOOTER //
// ./resources/assets/js/components/common/Pagination.jsx